import React, { useEffect, useState } from "react";
import api from "../../../../services/api";

export default function RoutesManager() {
  const [range, setRange] = useState({ from: "", to: "" });
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // === Получение маршрутов по диапазону ===
  useEffect(() => {
    if (!range.from || !range.to) return;

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await api.get("/routes/by-date", {
          params: { startDate: range.from, endDate: range.to },
        });
        setRoutes(res || []); // не .data, т.к. интерсептор уже возвращает data
      } catch (err) {
        console.error("Ошибка загрузки:", err);
        setError("Ошибка загрузки данных");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [range]);

  // === Обновление статуса ===
  const updateStatus = async (receiptId, status, reason) => {
    try {
      const updated = await api.patch(`/receipts/${receiptId}/status`, {
        status,
        reason,
      });
      setRoutes((prev) =>
        prev.map((route) => ({
          ...route,
          receipts: route.receipts.map((q) =>
            q.id === receiptId ? { ...q, ...updated } : q
          ),
        }))
      );
    } catch (err) {
      console.error("Ошибка обновления статуса:", err);
    }
  };

  // === Отметка "поехал" / "прибыл" ===
  const markTravel = async (receiptId, action) => {
    try {
      const updated = await api.patch(`/receipts/${receiptId}/travel`, {
        action,
      });
      // обновляем локально, чтобы сразу показать новое время
      setRoutes((prev) =>
        prev.map((route) => ({
          ...route,
          receipts: route.receipts.map((q) =>
            q.id === receiptId ? { ...q, ...updated } : q
          ),
        }))
      );
    } catch (err) {
      console.error("Ошибка при отметке времени:", err);
    }
  };

  return (
    <div
      style={{
        fontFamily: "Inter, sans-serif",
        padding: 20,
        background: "#f8fafc",
        minHeight: "100vh",
      }}
    >
      <h2 style={{ marginBottom: 20 }}>Маршруты по датам</h2>

      {/* === Фильтр по датам === */}
      <div
        style={{
          marginBottom: 20,
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <label>
          <span style={{ marginRight: 4 }}>С:</span>
          <input
            type="date"
            value={range.from}
            onChange={(e) => setRange((r) => ({ ...r, from: e.target.value }))}
            style={{
              padding: "4px 8px",
              border: "1px solid #ccc",
              borderRadius: 4,
            }}
          />
        </label>
        <label>
          <span style={{ marginRight: 4 }}>По:</span>
          <input
            type="date"
            value={range.to}
            onChange={(e) => setRange((r) => ({ ...r, to: e.target.value }))}
            style={{
              padding: "4px 8px",
              border: "1px solid #ccc",
              borderRadius: 4,
            }}
          />
        </label>
      </div>

      {loading && <p>Загрузка...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      {/* === Список маршрутов === */}
      {routes.map((route) => (
        <div
          key={route.id}
          style={{
            background: "#fff",
            border: "1px solid #e2e8f0",
            borderRadius: 10,
            marginBottom: 20,
            padding: 16,
            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
          }}
        >
          <h3 style={{ marginTop: 0, marginBottom: 12 }}>
            Маршрут №{route.route_number}{" "}
            <span style={{ color: "#6b7280" }}>
              — {route.driver || "без водителя"}
            </span>
          </h3>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: 14,
            }}
          >
            <thead>
              <tr
                style={{
                  textAlign: "left",
                  background: "#f1f5f9",
                  color: "#334155",
                }}
              >
                <th style={{ padding: 8 }}>ID</th>
                <th style={{ padding: 8 }}>Адрес</th>
                <th style={{ padding: 8 }}>Статус</th>
                <th style={{ padding: 8 }}>Причина</th>
                <th style={{ padding: 8 }}>Отправление</th>
                <th style={{ padding: 8 }}>Прибытие</th>
                <th style={{ padding: 8 }}>Действия</th>
              </tr>
            </thead>
            <tbody>
              {route.receipts?.map((r) => (
                <tr
                  key={r.id}
                  style={{
                    borderBottom: "1px solid #e2e8f0",
                    background: "#fff",
                  }}
                >
                  <td style={{ padding: 8 }}>{r.id}</td>
                  <td style={{ padding: 8 }}>{r.delivery_address}</td>
                  <td style={{ padding: 8 }}>{r.status}</td>
                  <td style={{ padding: 8 }}>{r.reason || "—"}</td>
                  <td style={{ padding: 8, color: "#2563eb" }}>
                    {r.departed_at
                      ? new Date(r.departed_at).toLocaleTimeString("ru-RU", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                      : "—"}
                  </td>
                  <td style={{ padding: 8, color: "#9333ea" }}>
                    {r.arrived_at
                      ? new Date(r.arrived_at).toLocaleTimeString("ru-RU", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                      : "—"}
                  </td>
                  <td style={{ padding: 8 }}>
                    <select
                      value={r.status}
                      onChange={(e) => updateStatus(r.id, e.target.value)}
                      style={{
                        padding: "4px 6px",
                        borderRadius: 4,
                        border: "1px solid #ccc",
                      }}
                    >
                      <option>Открыта</option>
                      <option>Закрыта</option>
                      <option>Не доставлено</option>
                    </select>

                    <button
                      onClick={() => markTravel(r.id, "depart")}
                      style={{
                        marginLeft: 8,
                        padding: "4px 8px",
                        background: "#3b82f6",
                        border: "none",
                        color: "#fff",
                        borderRadius: 4,
                        cursor: "pointer",
                      }}
                    >
                      Поехал
                    </button>
                    <button
                      onClick={() => markTravel(r.id, "arrive")}
                      style={{
                        marginLeft: 4,
                        padding: "4px 8px",
                        background: "#9333ea",
                        border: "none",
                        color: "#fff",
                        borderRadius: 4,
                        cursor: "pointer",
                      }}
                    >
                      Прибыл
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}

      {!loading && !routes.length && (
        <p style={{ color: "#6b7280" }}>Нет маршрутов за выбранный период</p>
      )}
    </div>
  );
}
